import React from "react";
import classNames from "classnames";
import { connect } from "react-redux";
import { notificacionSetInicial, notificacionCarga, notificacionActualiza, notificacionElimina } from "./notificaciones.act";
import { servicios } from "../properties";

const mapState = (state) => {
	return {
		loading: state.global.loading,
		notificaciones: state.notificaciones.listado,
		cliente: state.global.clienteUnico,
		refreshToken: state.global.refreshToken
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show });
		},
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo" : "NOTIFICACIONES", "mensaje": sMensaje });
		},
		carga: () => {
			dispatch(notificacionCarga());
		},
		addEvento: (evento) => {
			dispatch({ "type": "NOTIFICACIONES_SET_EVENT", "evento": evento});
		}
	};
};

class Notificaciones extends React.Component {
	state = {
		posicion: 0,
		activo : false,
		detalle : false,
		toggle: false
	}
	
	componentWillMount = () => {
		let $this = this;
		notificacionSetInicial().then((result) => {
			$this.props.carga();
		});
	}
	
	componentDidMount = () => {
		let $this = this;
		$this.props.onRef(this);
		
		$(".ntf-overlayer").off().click(function(e){ 
			if(e.target == this) {
				$this.cerrar();
			}
		});
	}
	
	detalleNotificacion = (item, key) => {
		$(".ntf-descripcion-parent").height($(".ntf-listado").height() - 30);
		this.props.addEvento("seleccionoNotificacion");
		this.setState({ "posicion": key });
		this.setState({ "activo": item.id });
		this.setState({ "detalle": item });
		notificacionActualiza({"nid": item.id});
	}

	eliminarNotificacion = () => {
		this.setState({ "activo": false });
		this.setState({ "detalle": null });
		notificacionElimina({"nid": this.state.detalle.id});
		this.props.addEvento("eliminoNotificacion");
	}

	atras = () => {
		let posicion = this.state.posicion;
		if(posicion-- && posicion >= 0) {
			this.detalleNotificacion(this.props.notificaciones[posicion], posicion);
		}
	}

	adelante = () => {
		let posicion = this.state.posicion;
		if(++posicion && posicion < this.props.notificaciones.length) {
			this.detalleNotificacion(this.props.notificaciones[posicion], posicion);
		}
	}

	abrir = () => {
		this.setState({ "toggle": true });
	} 

	cerrar = () => {
		this.setState({ "toggle": false, "activo": false, "detalle": null, "posicion": 0 });
	}

	abrirConfiguracionNotificaciones = ()=>{
		this.cerrar();
		$("#modal-gobierno").modal("toggle");
	}

	buildSrcGobNot = () => {
		let url = servicios.gobNotFrame.endPoint;
		url = `${url}?origen=PDC&clienteUnico=${this.props.cliente}`;
		return url;
	}

	closeModalGobNoti(){
		$("#modal-gobierno").modal("hide");
	}
	
	render() {
		var classes = classNames({
			"ntf-overlayer": true,
			"ntf-overlayer-opened": this.state.toggle
		});

		const urlGobNot = this.buildSrcGobNot();

		return (
			<div id="ntfMain">
				<div className={classes}>
					<div className="ntf-contenedor">
						<div className="row" style={{height: "100%",  marginRight: "0px"}}>
							<div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 nogap heightMensajes">
								<div className="header line-right">
									<ul>
										<li className="hidden-sm hidden-md hidden-lg hidden-xl"><a onClick={this.cerrar}><img src={require("./../img/icon-close.png")} /></a></li>
										<li className="floatLeft ntf-icon"><img src={require("./../img/notification-icon.png")} /></li>
										<li className="floatLeft">Notificaciones</li>
										<li className="floatRight ntf-icon"><a onClick={this.abrirConfiguracionNotificaciones}><img style={{width:"24px"}} src={require("../img/settings_24px.svg")} /></a></li>
									</ul>
								</div>
								
								<div className="ntf-listado line-right">
									{ this.props.notificaciones && this.props.notificaciones.map((item, i) => 
										<div className={"col-xs-12 notificacion " + (item.id == this.state.activo ? "activo" : "")} key={i}>
											<a onClick={this.detalleNotificacion.bind(this, item, i)} style={{display: "block"}}>
												<div className="concepto">
													<span>{item.concepto}</span>
													<span className="fecha">{item.fecha}</span>
												</div>
												<div className="cuerpo">
													<img src={item.icono} />
													<p className={(item.leido? "leido" : "noLeido")}>{item.titulo}</p>
												</div>
											</a>
											
											{ this.state.detalle && item.id == this.state.activo &&
												<div className="ntf-descripcion hidden-sm hidden-md hidden-lg hidden-xl">
													<p>{this.state.detalle.descripcion}</p>
													<div className="ntf-banner">
														<img src={this.state.detalle.banner} style={{"width": "100%", "height": "auto"}}/>
													</div>
													{ this.state.detalle.url && this.state.detalle.url != "" &&
														<div style={{"display": "block", "textAlign": "center"}}>
															<a href={this.state.detalle.url} target="_blank"> 
																Para mas informacion de click en este link
															</a>
														</div>
													}
													<ul>
														<li>
															<a onClick={this.eliminarNotificacion.bind(this)}><img src={require("./../img/trash.png")} /></a>
														</li>
													</ul>
												</div>
											}
										</div>
									)}
								</div>
							</div>
							<div className="col-lg-8 col-md-8 col-sm-8 col-xs-12 hidden-xs nogap heightDescripcion">
								<div className="header">
									<ul>
										<li style={{marginLeft:"15px"}}><a onClick={this.cerrar}><img src={require("./../img/icon-close.png")} /></a></li>
										{ this.state.detalle && 
											<div>
												<li>
													{ (this.state.posicion + 1) } de {this.props.notificaciones.length} 
													<a style={{margin:"0 15px"}} onClick={this.atras.bind(this)}> <img src={require("./../img/previous.png")} /> </a>
													<a style={{margin:"0 15px"}} onClick={this.adelante.bind(this)}> <img src={require("./../img/next.png")} /> </a>
												</li>
												<li className="line-right" style={{marginRight:"15px", paddingRight:"15px"}}><a onClick={this.eliminarNotificacion.bind(this)}><img src={require("./../img/trash.png")} /></a></li>
												<li className="floatLeft"> {this.state.detalle.concepto} </li>
											</div>
										}
									</ul>
								</div>
								<div className="ntf-descripcion-parent">
									{ this.state.detalle && 
										<div className="ntf-descripcion">
											<img src={this.state.detalle.icono} />
											
											<div className="ntf-mensaje">
												<div>
													<div>
														<span><b>{this.state.detalle.titulo}</b></span>
														<span className="fecha">{this.state.detalle.fecha}</span>
													</div>
													<p>{this.state.detalle.descripcion}</p>
													<div className="ntf-banner">
														<img src={this.state.detalle.banner} style={{"width": "100%", "height": "auto"}}/>
													</div>
													{ this.state.detalle.url && this.state.detalle.url != "" &&
														<div style={{"display": "block", "textAlign": "center"}}>
															<a href={this.state.detalle.url} target="_blank"> 
																Para mas informacion de click en este link
															</a>
														</div>
													}
												</div>
											</div>
										</div>
									}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="modal fade" id="modal-gobierno" role="dialog">
					<div className="modal-dialog" role="document" style={{width:"90%"}}>
						<div className="modal-content">
						    <div className="header line-right">
								<ul>
									<li className="floatRight ntf-icon"><a onClick={this.closeModalGobNoti}><img src={require("./../img/icon-close.png")} /></a></li>
								</ul>
							</div>
							<iframe
							frameBorder="0"
							scrolling="yes"
							style={{ overflow: "hidden", width: "100%" }}
							height="900"
							width="100%"
							src={urlGobNot}
							name={this.props.refreshToken}
							frameborder="0"
							></iframe>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Notificaciones);


// WEBPACK FOOTER //
// ./src/notificaciones/notificaciones.cmpt.js